module.exports = __webpack_public_path__ + "static/img/yk9200.8af8cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk9200.png
// module id = KFlm
// module chunks = 1